// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from "./App";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";

import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import StaffList from "./pages/Staff/StaffList";

import LeadList from "./pages/Leads/LeadList";
import LeadCreate from "./pages/Leads/LeadCreate";
import LeadView from "./pages/Leads/LeadView";
import SiteVisit from "./pages/Pipeline/SiteVisit";
import SiteVisitComplete from "./pages/Pipeline/SiteVisitComplete";
import Measurement from "./pages/Pipeline/Measurement";
import MeasurementPhotos from "./pages/Pipeline/MeasurementPhotos";
import Quotation from "./pages/Pipeline/Quotation";
import Prospects from "./pages/Prospects/Prospects";
import CreateQuotation from "./pages/Quotation/CreateQuotation";
import QuotationList from "./pages/Quotation/QuotationList";
// import QuotationList from "./pages/Quotation/QuotationList";
import ViewQuotation from "./pages/Quotation/ViewQuotation";
import { RouteTwoTone } from "@mui/icons-material";
import TaskList from "./pages/Tasks/TaskList";
import TaskForm from "./pages/Tasks/TaskForm";
import WorkflowHome from "./pages/Workflow/WorkflowHome";
import RoleList from "./pages/Roles/RoleList";
import TeamList from "./pages/Teams/TeamList";
import ProjectList from "./pages/Projects/ProjectList";
import ProjectDetails from "./pages/Projects/ProjectDetails";
import Settings from "./pages/Settings";
//import ProjectDashboard from "./pages/Projects/ProjectDashboard"; 
// import ProjectCreate from "./pages/Projects/ProjectCreate";
// import ProjectView from "./pages/Projects/ProjectView";
// import ProjectDetails from "./pages/Projects/ProjectDetails";
// import OnboardingWizard from "./pages/Onboarding/OnboardingWizard";
// import OwnerSignup from "./pages/Auth/OwnerSignup";
// import OnboardingWizard from "./pages/Onboarding/OnboardingWizard";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
<Route path="/verify-email" element={<VerifyEmail />} />
{/* <Route path="/onboarding" element={<OnboardingWizard />} />
<Route path="/owner-signup" element={<OwnerSignup />} /> */}
      <Route 
        path="/*"
        element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
      <Route path="staff" element={<StaffList />} />
      <Route path="projects" element={<ProjectList />} />
      
      <Route path="projects/:id" element={<ProjectDetails />} />
      {/* <Route path="projects/:id/dashboard" element={<ProjectDashboard />} /> */}
{/* <Route path="projects/create" element={<ProjectCreate />} />
<Route path="projects/:id" element={<ProjectView />} /> */}
      <Route path="workflow" element={<WorkflowHome />} />
<Route path="leads" element={<LeadList/>} />
<Route path="leads/create" element={<LeadCreate/>} />
<Route path="leads/:id" element={<LeadView/>} />
{/* ⭐ Pipeline routes must be OUTSIDE */}
  <Route path="leads/:id/site-visit" element={<SiteVisit />} />
  <Route path="leads/:id/site-visit/complete" element={<SiteVisitComplete />} />
  <Route path="leads/:id/measurement" element={<Measurement />} />
  <Route path="leads/:id/photos" element={<MeasurementPhotos />} />
  {/* <Route path="leads/:id/quotation" element={<Quotation />} /> */}
  <Route path="prospects" element={<Prospects />} />
  <Route path="roles" element={<RoleList />} />
  <Route path="teams" element={<TeamList />} />
  {/* <Route path="leads/:id/quotation/create" element={<CreateQuotation />} /> */}
  {/* <Route path="leads/:id/quotation/create" element={<CreateQuotation />} /> */}
  {/* <Route path="quotations" element={<QuotationList />} />

<Route path="quotations/:id" element={<ViewQuotation />} />
      
<Route path="leads/:id/quotation/create" element={<CreateQuotation />} /> */}
<Route path="leads/:id/quotation/create" element={<CreateQuotation />} />
<Route path="quotations" element={<QuotationList />} />
<Route path="quotations/:id" element={<ViewQuotation />} />
<Route path="tasks" element={<TaskList />} />
<Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  </BrowserRouter>
);


// Inside your <Route path="/*"> block:
